import React, { useState } from 'react';
import {
  Button,
  TextField,
  Paper,
  Modal,
  Typography,
  Container,
  AppBar,
  Toolbar,
  Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddCaste = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');
  const [newCaste, setNewCaste] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAddCaste = async (e) => {
    e.preventDefault();

    if (!newCaste.trim()) {
      setSnackbarMessage('Please enter a caste name');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning")
      return;
    }

    try {
      setLoading(true);
      const apiUrl = 'https://wsmsv1.aidigitalsec.com/api';
      const response = await fetch(`${apiUrl}/Caste`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({ casteName: newCaste }),
      });

      const data = await response.json();

      const message = (data && (data.msg || data.message)) || 'Caste has been added successfully.';
      const status = (data && data.status && data.status.toString().toLowerCase()) || '';
      const lowerMsg = (message || '').toString().toLowerCase();
      const errorKeywords = ['already exist', 'already exists', 'failed', 'error', 'unable', 'cannot'];
      const messageHasError = status.includes('failed') || errorKeywords.some(k => lowerMsg.includes(k));

      setModalType(messageHasError ? 'error' : 'success');
      setModalMessage(message);
      setModalOpen(true);

      if (!messageHasError) {
        setNewCaste('');
      }
    } catch (error) {
      console.error('API request error:', error);
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/caste/:encodedFormId'); // Navigate back to caste 
  };

  return (
    <Container>

      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Add Caste
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>

        <div
          className="row g-3 align-items-center"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: '100%',
          }}
        >
          <div class="col-md-8" style={{ width: '100%', }}>

            <TextField
              fullWidth
              label="Caste"
              id="castename"
              sx={{ marginBottom: 3 }}
              value={newCaste}
              required
              onChange={(e) => setNewCaste(e.target.value)}
            />

          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >

          <Button
            variant="contained"
            color="primary"
            sx={{ mx: 1 }}
            disabled={!newCaste} onClick={handleAddCaste}>
            <b>SAVE</b>
          </Button>
          <Button
            variant="contained"
            color="error"

            onClick={() => { setNewCaste("") }}
          >
            <b>RESET</b>
          </Button>
        </div>
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: modalType === 'error' ? '#8B0000' : '#0B1F40', padding: '12px 16px' }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'error' ? 'Error ❌' : 'Caste Added ✅'}
            </Typography>
          </Box>

          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage || (modalType === 'error' ? 'An error occurred.' : 'Caste has been added successfully.')}
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType !== 'error') navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default AddCaste;
